module.exports = __webpack_public_path__ + "static/media/spa_recompense.1ded2c19.jpeg";